import { createContext, useContext } from "react";
import type { IStoreApi } from "../api/type";
import type { AttributeFilterOptionType, CategoryType, OrderingOptionType, PaginationType, StoreItemType, StoreView } from "../types";

interface StoreContextType {
    api: IStoreApi;
    categories: CategoryType[];
    items: StoreItemType[];
    pagination: PaginationType
    availableOrdering: OrderingOptionType[];
    setAvailableOrdering: React.Dispatch<React.SetStateAction<OrderingOptionType[]>>;
    availableFiltering: Record<string, AttributeFilterOptionType[]>;
    setAvailableFiltering: React.Dispatch<React.SetStateAction<Record<string, AttributeFilterOptionType[]>>>;
    orderBy: OrderingOptionType
    setOrderBy: React.Dispatch<React.SetStateAction<OrderingOptionType>>
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>
    isFetching: boolean;
    errorMessage: string
    setErrorMessage: React.Dispatch<React.SetStateAction<string>>

    selectedCategory: CategoryType;
    setSelectedCategory: React.Dispatch<React.SetStateAction<CategoryType>>;
    selectCategory: (category: string) => void;

    showFilters: boolean;
    setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;

    searchTerm: string;
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>;

    attributeFilters: number[];
    setAttributeFilter: React.Dispatch<React.SetStateAction<number[]>>;

    view: StoreView;
    setView: (view: StoreView) => void;
}

export const StoreContext = createContext<StoreContextType | undefined>(undefined)

export function useStoreContext() {
    const context = useContext(StoreContext)
    if (!context) {
        throw new Error('Store compound components must be used within Store')
    }
    return context
}